export const MAPPED = "mapped"
export const UNMAPPED = "unmapped"

export const CONFIGURATION_FIELD_TYPES = {
  SELECT: "select",
  DATE: "date",
}

export const SYNC_STATUSES = {
  DESTROYED: "destroyed",
  EXCLUDED: "excluded",
  FAILED: "failed",
  PENDING: "pending",
  SUCCESS: "success",
}

// Order the marina cares about: the statuses that need attention come first.
export const SYNC_STATUS_FILTER_OPTIONS = [
  SYNC_STATUSES.FAILED,
  SYNC_STATUSES.EXCLUDED,
  SYNC_STATUSES.PENDING,
  SYNC_STATUSES.SUCCESS,
  SYNC_STATUSES.DESTROYED,
]

export const DOCUMENT_TYPE_OPTIONS = [
  { value: "invoice", label: "Invoice" },
  { value: "credit_note", label: "Credit note" },
  { value: "payment", label: "Payment" },
  { value: "refund", label: "Refund" },
]

export const documentTypeLabel = (documentType) =>
  DOCUMENT_TYPE_OPTIONS.find((option) => option.value === documentType)
    ?.label || documentType
